"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _lodash = _interopRequireDefault(require("lodash"));
var _bluebird = _interopRequireDefault(require("bluebird"));
class AssetsApi {
  /**
   * Represents a Assets Api.
   * @constructor
   */
  constructor(_ref) {
    let {
      assetsUrl,
      userToken
    } = _ref;
    this.assetsUrl = assetsUrl;
    this.userToken = userToken;
  }
  get authHeaders() {
    return {
      'Content-Type': 'application/json',
      'AuthenticationToken': this.userToken
    };
  }
  async getHeaders() {
    return {
      'Content-Type': 'application/json',
      'AuthenticationToken': this.userToken
    };
  }

  /**
   * Create new folder
   * @param {string} folderName folder path
   * @returns {Promise} promise to create a folder
   */
  createFolder(folderName) {
    const normalizedFolderName = _lodash.default.replace(folderName, /\/$/, '');
    return this._request('post', null, {
      Folder: `${normalizedFolderName}/`
    });
  }

  /**
   * Delete asset by key
   * @param {string} key key of the asset
   * @returns {Promise} promise to delete asset
   */
  deleteAsset(key) {
    return this._request('delete', {
      Key: key
    });
  }

  /**
   * Get asset details
   * @param {string} key key of the asset
   * @returns {Promise} to get asset details
   */
  fetchAssetDetails(key) {
    return this._request('get', {
      Key: key
    });
  }

  /**
   * Get the list of assets
   * @param {Object} [params] assets prefix
   * @returns {Promise} promise to fetch assets
   */
  fetchAssets(params) {
    return this._request('get', {
      Prefix: _lodash.default.get(params, 'prefix')
    });
  }

  /**
   * Get the list of assets
   * @param {Object} [prefix] assets prefix
   * @param {Object} [search] search pattern for asset
   * @param {Object} [excludeFolders=false] if true exclude folders from search
   * @returns {Promise} promise to fetch assets
   */
  searchAssets(_ref2) {
    let {
      prefix,
      search,
      excludeFolders = false
    } = _ref2;
    return this._request('get', {
      Prefix: prefix,
      Search: search,
      ExcludeFolders: excludeFolders
    }).then(data => _lodash.default.get(data, 'Results', []));
  }

  /**
   * Update ACL for asset
   * @param {string} key key of the asset
   * @param {string} acl new acl value (e.g. bucket-owner-full-control, public-read)
   * @returns {Promise} promise to update asset ACL
   */
  updateAssetAcl(key, acl) {
    return this._request('put', {
      Key: key,
      ACL: acl
    });
  }

  /**
   * Upload a file
   * @param {Object} file file to upload
   * @param {string} fileName full name of the file
   * @param {string} acl file ACL (e.g. bucket-owner-full-control, public-read)
   * @param {string} contentType file content type
   * @param {Function} [progress] progress callback
   * @returns {Promise} promise to upload a file
   */
  uploadFile(_ref3) {
    let {
      file,
      fileName,
      acl,
      contentType,
      progress
    } = _ref3;
    return this._fetchS3Details(fileName, acl).then(async policy => {
      const formData = new FormData(); //eslint-disable-line no-undef
      formData.append('content-type', contentType || 'text/plain');
      _lodash.default.forEach(policy.params, (value, key) => {
        formData.append(key, value);
      });
      formData.append('File', file);
      const headers = await this.getHeaders();
      return _axios.default.post(policy.endpoint_url, formData, {
        headers,
        onUploadProgress: _lodash.default.isFunction(progress) ? event => progress(event, fileName) : null
      });
      // return Vue.http.post(policy.endpoint_url, formData, {
      //     headers,
      //     progress : _.isFunction(progress) ? event => progress(event, fileName) : null
      // });
    }).then(response => response.data);
  }

  /**
   * Create a file policy
   * @param {string} fileName full name of a file
   * @param {string} acl file ACL (e.g. bucket-owner-full-control, public-read)
   * @returns {Promise} promise to create policy
   */
  _fetchS3Details(fileName, acl) {
    return this._request('post', null, {
      FileName: fileName,
      Params: {
        ACL: acl
      }
    });
  }

  /**
   * Make request to Files & Data
   * @param {string} method HTTP method (e.g. get, put, post, delete)
   * @param {Object} [params] list of query params
   * @param {Object} [body] body of a request
   * @returns {Promise} promise to make request
   * @private
   */
  async _request(method, params, body) {
    const headers = await this.getHeaders();
    const options = {
      headers,
      params: _lodash.default.omitBy(params, _lodash.default.isNil)
    };
    const requestArgs = [this.assetsUrl];
    switch (method) {
      case 'get':
      case 'head':
      case 'delete':
      case 'jsonp':
        requestArgs.push(options);
        break;
      case 'post':
      case 'put':
      case 'patch':
        requestArgs.push(body);
        requestArgs.push(options);
        break;
      default:
        return _bluebird.default.reject(new Error(`Unknown method: "${method}"`));
    }
    return _bluebird.default.try(() => _axios.default[method](...requestArgs)).then(response => response.data);
  }
}
var _default = AssetsApi;
exports.default = _default;